import hero from './hero'
import menu from './menu'
import footer from './footer'
import property_cards from './property_cards'
import services from './services'
import work_process from './work_process'
import promo_metrics from './promo_metrics'
import our_projects from './our_projects'
import call_to_action from './call_to_action'
import statistics from './statistics'
import tuik from './tuik'
import sales_chart from './sales_chart'
import construction from './construction'
import login from './login'
import about from './about'
import property_detail from './property_detail'
import mini_filter_bar from './mini_filter_bar'
import developer from './developer'
import residential_complex from './residential_complex'
import price_estimation from './price_estimation'
import cookies from './cookies'
import seo_pages from './seo_pages'
import ai_explanation from './ai_explanation'
import lead_modal from './lead_modal'


export default {
  footer, menu, hero, property_cards, services, work_process,
  promo_metrics, our_projects, call_to_action, statistics,
  tuik, sales_chart, construction, login, about, property_detail, mini_filter_bar,
  developer, residential_complex, price_estimation, cookies, seo_pages, ai_explanation,
  lead_modal
}